import { BridgeConfig } from '../model/bridge-config';
import BaseBridge from '../base-bridge';

export default class Bridge extends BaseBridge {
  constructor(config: BridgeConfig) {
    super(config);
    window.addEventListener('message', this.onReceiveMessage, false);
  }

  override sendJsonMessage(message: Record<string, any>): void {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(message, this.config.origin);
    }
  }
}
